var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBookDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40000553_9872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.75081H16.25V18.1258C16.25 18.3862 16.2012 18.6304 16.1035 18.8582C16.0059 19.0861 15.8724 19.2847 15.7031 19.4539C15.5339 19.6232 15.3353 19.7567 15.1074 19.8543C14.8796 19.952 14.6354 20.0008 14.375 20.0008H4.375C4.11458 20.0008 3.87044 19.952 3.64258 19.8543C3.41471 19.7567 3.21615 19.6232 3.04688 19.4539C2.8776 19.2847 2.74414 19.0861 2.64648 18.8582C2.54883 18.6304 2.5 18.3862 2.5 18.1258V3.75081H1.25V2.50081H6.25V1.25081C6.25 1.07503 6.28255 0.912272 6.34766 0.762533C6.41276 0.612793 6.50065 0.482585 6.61133 0.371908C6.72201 0.26123 6.85547 0.170085 7.01172 0.0984701C7.16797 0.0268555 7.33073 -0.00569662 7.5 0.000813802H11.25C11.4258 0.000813802 11.5885 0.0333659 11.7383 0.0984701C11.888 0.163574 12.0182 0.251465 12.1289 0.362142C12.2396 0.472819 12.3307 0.606283 12.4023 0.762533C12.474 0.918783 12.5065 1.08154 12.5 1.25081V2.50081H17.5V3.75081ZM7.5 2.50081H11.25V1.25081H7.5V2.50081ZM15 3.75081H3.75V18.1258C3.75 18.2951 3.81185 18.4416 3.93555 18.5653C4.05924 18.689 4.20573 18.7508 4.375 18.7508H14.375C14.5443 18.7508 14.6908 18.689 14.8145 18.5653C14.9382 18.4416 15 18.2951 15 18.1258V3.75081ZM7.5 16.2508H6.25V6.25081H7.5V16.2508ZM10 16.2508H8.75V6.25081H10V16.2508ZM12.5 16.2508H11.25V6.25081H12.5V16.2508Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40000553_9872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBookDeleteIcon);
export default __webpack_public_path__ + "static/media/check-book-delete-icon.ef952d82cd694b10daf0ac5daaaa6865.svg";
export { ForwardRef as ReactComponent };